import type { Reservation } from '../_queries';
import { day } from '@vrplatform/utils';

export const formatFinancialLockMessage = (
  lock: Reservation['financials'][0]['lock']
) => {
  const locked = lock?.status === 'locked';
  const reasons: string[] = [];

  if (locked) {
    if (lock?.booksClosed?.date) {
      reasons.push(
        `Books closed through ${day(lock.booksClosed.date).subtract(1, 'day').format('ll')}`
      );
    }
    if (
      lock?.statementPeriod?.hits.length &&
      !lock?.ownerStatement?.ids?.length
    ) {
      reasons.push(
        `Locked due to an owner statement being published on the same month as this financial`
      );
    }

    return reasons.join('; ') || 'This financial is locked';
  }

  return undefined;
};
